import { Grid } from '@mui/material';
import { DynamicBreadcrumbs } from 'src/components/Breadcrumbs';
import WidgetList from 'src/components/WidgetList';
import { IMicrositeDynamicPageConfig } from 'src/interfaces/page';
import Error from '../../../pages/_error';
import { StyledBox } from './DynamicPage.styles';

export const DynamicPage = ({
  pageData,
  breadcrumbsCount,
}: {
  pageData?: IMicrositeDynamicPageConfig;
  breadcrumbsCount?: number;
}) => {
  const hideBreadcrumbs = pageData?.configuration?.hideBreadcrumbs;

  if (pageData) {
    return (
      <StyledBox data-testid="dynamic-page">
        {!hideBreadcrumbs && (
          <DynamicBreadcrumbs
            pageId={pageData.id}
            breadcrumbsCount={breadcrumbsCount}
          />
        )}

        <Grid container item direction="column">
          <Grid item>
            <WidgetList widgets={pageData?.configuredWidgets} />
          </Grid>
        </Grid>
      </StyledBox>
    );
  }

  return <Error statusCode={404} />;
};
